import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DashboardPartnerModel } from '../shared/models/dashboard.model';
import { AuthTokenService } from '../shared/services/auth-token.service';
import { LanguageService } from '../shared/services/language.service';
import { PpbApiService } from '../shared/services/ppb-api.service';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private api: PpbApiService,
    private authTokenService: AuthTokenService,
    private languageService: LanguageService
  ) {
  }

  getDashboard(): Observable<DashboardPartnerModel[]> {
    return this.api.get<DashboardPartnerModel[]>('/api/v1/dashboard');
  }

  redirect(url: string, uuid: string, addLanguage: boolean = false): void {
    let uri = encodeURIComponent(`${window.origin}/auth-api/v1/public/limited-time-token/${uuid}`)
    if (addLanguage) {
      uri += `&lang=${this.languageService.selectedLanguage$.value}`
    }

    window.open(url + uri, '_blank')
  }

  exchangeSecretForUuid(partner: DashboardPartnerModel): Observable<any> {
    const data = {
      partnerId: partner.partnerCode,
      partnerName: partner.partnerName,
      refreshToken: this.authTokenService.getRefreshToken(),
      accessToken: this.authTokenService.getAccessToken()
    };
    return this.api.post(
      `/auth-api/v1/public/limited-time-token`,
      data,
      new HttpParams(),
    );
  }

}
